<template>
  <div class="home">
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a class="fs-12 ftc-000000 line-h40 go-login more" href="/show">
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            您好，{{
            nickname
            }}
          </a>
          <a href="/login" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a href="/cgList" class="fl fs-12 ftc-000000 line-h40">
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Show">首页</a>
          </li>
          <li>
            <a href="/Show">活动启事</a>
          </li>
          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a href="/lwList">上传作品</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>
        </ul>

        <!-- <a class="uploadfile"  href="/bmcs">上传作品</a> -->
      </div>
    </div>
    <div class="main w1200">
      <div style="color:red;font-size:15px;margin-left:20px;margin-top: 20px;">
        您的论文参加语文报社第五届“新时代语文教育学术展评活动”，如在接下来的评审中达到知网要求，组委会将推荐收入中国知网重要会议论文全文数据库（CPCD）《新时代语文教育学术展评活动论文集》中。为保证您的权益，我们提请您在自愿的前提下签署这份出版授权书。请通过平台补传授权书，逾期不交者将视作不同意而自动放弃收录。
在签署时，请下载授权书并准确填入自己的文章信息（填入授权书下表格），再将填好信息的授权书上传——这点非常重要  (上传授权书时请手写签字，完毕后请将授权书拍照，以图片的形式上传)。
      </div>
      <div class="w1200">
        <!-- 表单内容开始-->

        <div class="update-div">
           <el-input v-model="worksname" placeholder="请输入上传作品的题目，不得超过20个字"></el-input>
          <a href="javascript:;" class="file">
            上传{{workstype}}
            <input
              type="file"
              @change="uploadInputchange"
              id="uploadFileInput"
              accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />
          </a>
          <el-input v-model="doc" v-show="isShow2"></el-input>
        
          <a href="https://sfds1.zhyww.cn/lwmb.docx" class="sqs-a">  <i class="el-icon-link" style="font-size: 20px; color: #409eff"></i>下载论文模板</a>

          
          <div v-show="isShow1" class="fileName">
            {{fileName}}
            <span style="margin-left: 5px;"></span>
            {{ percent }}%
          </div>
<br><br>


          <a href="javascript:;" class="file">
            上传授权书
            <input
              type="file"
              @change="uploadInputchange1"
              id="uploadFileInput1"
              accept="image/*"
            />
          </a>
          <el-input v-model="doc" v-show="isShow2"></el-input>
            (上传授权书时请手写签字，完毕后请将授权书拍照，以图片的形式上传)。
          <a href="https://sfds1.zhyww.cn/zwxszpsqs1.docx" class="sqs-a">  <i class="el-icon-link" style="font-size: 20px; color: #409eff"></i>下载授权书模板</a>

           <div v-show="isShow1s" class="fileName">
            {{fileNamesqs}}
            <span style="margin-left: 5px;"></span>
            {{ percent }}%
          </div>


           <div class="save-b">
             <el-button type="primary" @click="saveWork">修改</el-button>
           </div>
        </div>
        <el-divider></el-divider>
        <div class="shili">
            <p  style="font-size:15px;font-weight: bold;">请按照以下标准格式提交作品</p><br>
          <img v-if="workstype=='学术论文'" src="../assets/images/lwmb.jpg" >
          <img v-if="workstype=='教学设计'" src="../assets/images/sjmb.jpg" >
          </div>
        <!-- <img src="../assets/images/lwmb.jpg" class="title_fudong" > -->
        <!-- 表单内容结束-->
      </div>
        <br><br><br>
    </div>
    <div
      class="footer"
      style="
        background: url(('../../assets/images/foot.png')) top center no-repeat;
      "
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>
            语文网版权所有 未经书面授权 不得复制或建立镜像
            晋公网安备14010902000073号
          </p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import * as qiniu from "qiniu-js";
import { GetOrderInfo,UpdateOrderno } from "@/request/api";
export default {
  data() {
    return {
isShow1s: false,
      isShow1: false,
      isShow2: false,
      isShow11: false,
      doc: null,
      doc1: null,
      fileName: null,
      fileNamesqs: null,
      percent: 100,
      username: null,
      phone: null,
      schoolArea: null,
      workUnit: null,
      shippingAddress: null,
      studySection: null,
      userid: null,
      workstype:null,
      oid:null,
      orderno:null,
      worksname:null,
    };
  },
  created() {
    var openid = sessionStorage.getItem("openid");
    if (openid == null) {
      this.$router.push({ path: "/" });
    }
    this.nickname = sessionStorage.getItem("nickname");
    this.worksname = sessionStorage.getItem("worksname");
    this.oid = sessionStorage.getItem("oid");
    var url = window.location.href; //获取url地址
    var out_trade_no = url.split("out_trade_no=")[1]; //从获取到的地址中截取openid
    console.log("******", out_trade_no);
    this.orderno = out_trade_no;
    let that = this;
    GetOrderInfo({ orderno: out_trade_no })
      .then(function(response) {
        console.log("#####:" + response.data.states);
        if (response.data.states == 1) {
          if (
            response.data.data.username == sessionStorage.getItem("username")
          ) {
            that.username = response.data.data.username;
            that.phone = response.data.data.phone;
            that.schoolArea = response.data.data.schoolArea;
            that.workUnit = response.data.data.workUnit;
            that.shippingAddress = response.data.data.shippingAddress;
            that.studySection = response.data.data.studySection;
            that.userid = response.data.data.id;
            that.workstype = response.data.xszpOrder.workstype;
            that.fileName = response.data.xszpOrder.worksname;
            that.fileNamesqs = response.data.xszpOrder.sqspath;
            that.doc = response.data.xszpOrder.workspath;

          } else {
            that.$router.push({ path: "/" });
          }
        } else {
          that.$router.push({ path: "/" });
        }
      })
      .catch(function(reason) {
        alert("error");
      });
  },
  methods: {
    toUserHome(val) {
      let that = this;
      that.$router.push({ path: "/userHome" });
    },
    uploadInputchange() {
      let file = document.getElementById("uploadFileInput").files[0]; //选择的图片文件
      this.uploadImgToQiniu(file);
    },
    uploadImgToQiniu(file) {
      let data = new FormData();
      var that = this;
      let token = null;
      this.$axios
        .get("https://appconsole.zhyww.cn/api/qiniuToken")
        .then(function(res) {
          token = res.data;
          console.log("*****************:", token);
          console.log("token:", token);
          let uptoken = token;
          let key = "xszp/" + new Date().getTime() + file.name;
          that.fileName = file.name;
          var config = {
            useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
            //region: qiniu.region.z0,      //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域。  我这里是华东区
            domain: "https://ywbs1.zhyww.cn", //配置好的七牛云域名  如   https://cdn.qniyun.com/
            chunkSize: 400, //每个分片的大小，单位mb，默认值3
            forceDirect: true //直传还是断点续传方式，true为直传
          };
          var putExtra = {
            fname: file.name, //文件原始文件名
            params: {},
            mimeType: [] || null
            // ...config,
          };
          var observable = qiniu.upload(file, key, uptoken, putExtra, config);
          observable.subscribe({
            next: result => {
              //主要用来展示进度
              that.isShow11 = false;
              that.isShow1 = true;
              that.showRentPrise = true;
              console.log(result.total.percent);

              that.percent = parseFloat(result.total.percent).toFixed(2);
            },

            complete: result => {
              //上传成功后触发。包含文件地址。
              that.doc = "https://ywbs1.zhyww.cn/" + result.key;
              that.isShow1 = true;
              that.showRentPrise = false;
              console.log(that.doc);
              //alert("上传成功");
              that.$alert("上传成功", "上传", {
                confirmButtonText: "确定",
                callback: action => {
                  this.$message({
                    type: "info",
                    message: `action: ${action}`
                  });
                }
              });
              resolve(result);
            }
          });
        })
        .catch(function(err) {
          console.log(err);
        });
    },





uploadInputchange1() {
      let file = document.getElementById("uploadFileInput1").files[0]; //选择的图片文件
      this.uploadImgToQiniu1(file);
    },
    uploadImgToQiniu1(file) {
      let data = new FormData();
      var that = this;
      let token = null;
      this.$axios
        .get("https://appconsole.zhyww.cn/api/qiniuToken")
        .then(function(res) {
          token = res.data;
          console.log("*****************:", token);
          console.log("token:", token);
          let uptoken = token;
          let key = "xszp/" + new Date().getTime() + file.name;
          that.fileNamesqs = file.name;
          var config = {
            useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
            //region: qiniu.region.z0,      //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域。  我这里是华东区
            domain: "https://ywbs1.zhyww.cn", //配置好的七牛云域名  如   https://cdn.qniyun.com/
            chunkSize: 400, //每个分片的大小，单位mb，默认值3
            forceDirect: true //直传还是断点续传方式，true为直传
          };
          var putExtra = {
            fname: file.name, //文件原始文件名
            params: {},
            mimeType: [] || null
            // ...config,
          };
          var observable = qiniu.upload(file, key, uptoken, putExtra, config);
          observable.subscribe({
            next: result => {
              //主要用来展示进度
              that.isShow11 = false;
              that.isShow1s = true;
              that.showRentPrise = true;
              console.log(result.total.percent);

              that.percent = parseFloat(result.total.percent).toFixed(2);
            },

            complete: result => {
              //上传成功后触发。包含文件地址。
              that.doc1 = "https://ywbs1.zhyww.cn/" + result.key;
              that.isShow1s = true;
              that.showRentPrise = false;
              console.log(that.doc1);
              //alert("上传成功");
              that.$alert("上传成功", "上传", {
                confirmButtonText: "确定",
                callback: action => {
                  this.$message({
                    type: "info",
                    message: `action: ${action}`
                  });
                }
              });
              resolve(result);
            }
          });
        })
        .catch(function(err) {
          console.log(err);
        });
    },


















    saveWork(){
       var that = this;
       if(that.doc == null){
          alert("还未上传作品")
          sessionStorage.removeItem("oid");
       } else {
          UpdateOrderno({userid:sessionStorage.getItem("userId"),oid:that.oid,orderno:that.orderno,worksname:that.worksname,worksPath:that.doc,sqspath:that.doc1}).then(function(res) {
            console.log("res2222:", res.data.states);
            if (res.data.states == 1) {
              alert("修改成功！");
              that.$router.push({ path: "/lwList" });
            } else {
              alert("保存失败");
              that.$router.push({ path: "/lwList" });
            }
          });
          sessionStorage.removeItem("oid");
       }
    }
  }
};
</script>
